import { Post } from "services/apiService";
import {
  CREATE_PURCHASE_ORDERS_REQUEST,
  CREATE_PURCHASE_ORDERS_SUCCESS,
  CREATE_PURCHASE_ORDERS_ERROR,
} from "redux/actions/action-type";
import { BASE_URL, SOMS_API_KEY } from "services/CONSTANTS";
import { encryptString } from "components/common/EncryptDecrypt";

export const createPO =
  ({ payloadArray }) =>
  async (dispatch) => {
    let email = "";
    const sessionData = sessionStorage.getItem("persist:root");

    if (sessionData) {
      const parsedData = JSON.parse(sessionData);
      const userData = JSON.parse(parsedData.user);
      email = userData.loginResponse.email;
    }
    const encryptedEmailId = await encryptString(email);

    const apiUrl = `${BASE_URL}manualporequests?apikey=${SOMS_API_KEY}`;

    dispatch({ type: CREATE_PURCHASE_ORDERS_REQUEST });

    try {
      const apiCalls = payloadArray.map((payload) =>
        Post({
          url: apiUrl,
          params: {
            ...payload,
            userId: encryptedEmailId,
          },
          config: {},
        })
      );

      const responses = await Promise.all(apiCalls);
      const allSuccessful = responses.every(
        (response) => response.status === 200
      );

      if (allSuccessful) {
        dispatch({
          type: CREATE_PURCHASE_ORDERS_SUCCESS,
          payload: responses.map((response) => response.data),
        });
      } else {
        const errorResponse = responses.find(
          (response) => response.status !== 200
        );
        dispatch({
          type: CREATE_PURCHASE_ORDERS_ERROR,
          payload: errorResponse,
        });
      }
    } catch (error) {
      dispatch({
        type: CREATE_PURCHASE_ORDERS_ERROR,
        payload: error,
      });
    }
  };
